<template>
  <div id="product">
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb
            :link="[{ name: 'Quản lý khách hàng', active: true }]"
          ></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 bg-lighter">
      <loading :active.sync="pending" :is-full-page="true"></loading>
      <div class="area-one">
        <div class="row">
          <div class="col">
            <div class="soft-control">
              <div class="card mb-1">
                <control-panel
                  :permission="{
                    create: 'customer_create',
                    edit: 'customer_update',
                    print: 'customer_print',
                    export: 'customer_export',
                    delete: 'customer_delete'
                  }"
                  :countChecked="countChecked"
                  @doAddNew="handleCreate"
                  @doEdit="handleUpdate"
                  @search="handleSearch"
                  @copy="handleCopy"
                  :help="handleHelp"
                  @doDelete="handleDelete"
                ></control-panel>
                <div class="row p-1">
                  <div class="col-md-8">
                    <soft-table
                      @rowSelected="tbSetRowSelected"
                      @rowClicked="tbRowClicked"
                      class="table align-items-center table-flush"
                      tbody-classes="list"
                      :pending="false"
                      :dataTable="tableData"
                      :fields="fields"
                      :minHeight="hMainTable"
                      :contextMenus="[
                        {
                          key: 'verify',
                          icon: 'fa-users-cog',
                          label: 'Duyệt hồ sơ'
                        },
                        {
                          key: 'edit',
                          icon: 'fa-tasks',
                          label: 'Cập nhật hồ sơ'
                        },
                        {
                          key: 'editManage',
                          icon: 'fa-tasks',
                          label: 'Đổi người phụ trách'
                        }
                      ]"
                      @contextMenuItemClick="tbHandleContextMenuItemClick"
                      ref="soft-table"
                    >
                      <template v-slot:cell(isBlock)="{ item }">
                        <span
                          @click="handleBlock(item)"
                          v-if="!item.isBlock"
                          class="badge badge-danger"
                          >Vô hiệu hoá</span
                        >
                        <span
                          v-else
                          @click="handleUnBlock(item)"
                          class="badge badge-success"
                          >Kích hoạt</span
                        >
                      </template>
                      <template v-slot:cell(customerGroup)="{ value }">
                        <span class="badge badge-warning">
                          {{ value.name }}
                        </span>
                      </template>
                      <template v-slot:cell(userCreate)="{ value }">
                        <span v-if="value.id" class="badge badge-primary">
                          {{ value.username }}
                        </span>
                      </template>
                      <template v-slot:cell(userVerify)="{ value }">
                        <span v-if="value.id" class="badge badge-success">
                          {{ value.username }}
                        </span>
                        <span v-else class="badge badge-danger"
                          >Chưa được duyệt</span
                        >
                      </template>
                      <template v-slot:cell(userManage)="{ value }">
                        <span v-if="value.id" class="badge badge-info">
                          {{ value.name }}
                        </span>
                        <span v-else class="badge badge-danger"
                          >Chưa có người hỗ trợ</span
                        >
                      </template>
                      <template>
                        <pagination
                          class="mt-2 mb-2 mr-2"
                          slot="footer"
                          :total="listQuery.total"
                          :perPage="listQuery.limit"
                          @change="pagChange"
                        />
                      </template>
                    </soft-table>
                  </div>
                  <div class="col-md-4">
                    <div class="card">
                      <div class="card-content p-2">
                        <template v-if="customer && customer.id">
                          <div class="row">
                            <div class="col-5">
                              <img
                                class="img-fluid"
                                v-holder="{
                                  img: '150x150',
                                  text: 'Hình đại diện'
                                }"
                                @error="$imgHolder"
                                :src="this.$mediaURI + customer.avatar"
                              />
                            </div>
                            <div class="col-7 p-0">
                              <ul class="pl-4 pt-2">
                                <li>
                                  <i class="fa fa-phone-square-alt"></i> :
                                  <span>{{ customer.mobile }}</span>
                                </li>
                                <li>
                                  Đặt thù :
                                  <span>{{ customer.fax }}</span>
                                </li>
                                <li>
                                  <i class="ni ni-world"></i> :
                                  <span>{{ customer.website }}</span>
                                </li>
                                <li>
                                  <i class="fa fa-layer-group"></i> :
                                  <span v-if="customer.customerGroup">
                                    {{ customer.customerGroup.name }}
                                  </span>
                                </li>
                                <li>
                                  <i class="fa fa-envelope-open-text"></i> :
                                  <span>{{ customer.email }}</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div class="col text-center">
                            <hr class="m-3" />
                            <h3>{{ customer.code }} - {{ customer.name }}</h3>
                            <span>Đ/c : {{ customer.address }}</span>
                            <br />
                            <span>MST : {{ customer.taxCode }}</span>
                            <br />
                            <span>Ngành nghề : {{ customer.career }}</span>
                            <br />
                            <span>
                              Quy mô: {{ customer.factoryScale }} - Số lượng
                              nhân viên : {{ customer.employeeNumber }}
                            </span>
                            <br />
                          </div>
                        </template>
                      </div>
                    </div>
                    <button
                      class="btn btn-primary btn-lg btn-block mt-4"
                      style="margin:0 auto"
                      @click="handleCreateQuota"
                      :disabled="customer.id ? false : true"
                    >
                      TẠO MỚI BÁO GIÁ
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="area-two" :style="`height:${$hSecondaryContent}px`">
        <div class="row">
          <div class="col">
            <div class="card p-2">
              <b-tabs>
                <b-tab title="Người liên hệ">
                  <customer-contact
                    ref="customer-contact"
                    class="soft-control mt-2"
                    @changeData="handleChangeDataCustomerContact"
                  ></customer-contact>
                </b-tab>
                <b-tab title="Lịch sử báo giá">
                  <history-quota
                    @doCreateQuote="handleCreateQuota"
                    class="soft-control mt-2"
                    :customerId="customer.id"
                  />
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
    <quota-modal ref="quota-modal" />
    <customer-modal @submit:success="fetchData" ref="customer-modal" />
    <user-manage ref="userManage"></user-manage>
    <event @doAdd="handleCreate" @doEdit="handleUpdate"></event>
  </div>
</template>

<script>
import { customerService } from "@/_services";

import CustomerModal from "./components/CustomerModal";
import CustomerContact from "./components/CustomerContact";
import HistoryQuota from "./components/HistoryQuota";
import QuotaModal from "@/views/Quoata/components/QuotaModal";
import UserManage from "./__UserManageModal";

export default {
  name: "customer-manage",
  components: {
    HistoryQuota,
    CustomerModal,
    CustomerContact,
    QuotaModal,
    UserManage
  },
  data: () => ({
    tabName: "product",
    listQuery: {
      page: 1,
      limit: 10,
      total: 0
    },
    pending: false,
    countChecked: 0,
    tableData: [],
    fields: [
      {
        variant: "primary",
        key: "id",
        class: "checkbox"
      },
      {
        key: "code",
        label: "Mã khách hàng",
        sortable: true
      },
      {
        stickyColumn: true,
        key: "name",
        variant: "success",
        label: "Tên khách hàng",
        sortable: true
      },
      {
        key: "short_name",
        variant: "warning",
        label: "Tên viết tắc",
        sortable: true
      },
      "fax",
      {
        tdClass: "text-center",
        key: "career",
        label: "Nghành nghề",
        sortable: true
      },
      {
        key: "employeeNumber",
        tdClass: "text-center",
        label: "Số lượng nhân viên",
        sortable: true
      },
      {
        tdClass: "text-center",
        key: "factoryScale",
        label: "Quy mô nhà xưởng",
        sortable: true
      },
      {
        key: "email",
        sortable: true
      },
      {
        tdClass: "text-center",
        key: "taxCode",
        label: "Mã số thuế",
        sortable: true
      },
      {
        tdClass: "text-center",
        key: "tax",
        label: "Thuế suất",
        sortable: true
      },
      {
        key: "address",
        label: "Địa chỉ",
        sortable: true
      },
      {
        key: "website",
        sortable: true
      },
      {
        tdClass: "text-center",
        key: "mobile",
        label: "Điện thoại",
        sortable: true
      },
      {
        tdClass: "text-center",
        key: "tax",
        label: "Thuế suất",
        sortable: true
      },
      {
        tdClass: "text-center",
        key: "userCreate",
        label: "Người tạo",
        sortable: true
      },
      {
        tdClass: "text-center",
        key: "userManage",
        label: "Người phụ trách",
        sortable: true
      },
      {
        tdClass: "text-center",
        key: "userVerify",
        label: "Người duyệt hồ sơ",
        sortable: true
      },
      {
        tdClass: "text-center",
        key: "isBlock",
        sortable: true,
        label: "Trạng thái"
      },
      {
        tdClass: "text-center",
        key: "customerGroup",
        sortable: true,
        label: "Nhóm Khách hàng"
      },
      {
        tdClass: "text-center",
        key: "dateCreated",
        sortable: true,
        label: "Ngày tạo"
      },
      {
        tdClass: "text-center",
        key: "dateUpdated",
        sortable: true,
        label: "Lần cuối sửa đổi"
      }
    ],
    customer: {},
    customerSelecteds: [],
    lastIndexCustomerSelected: 0,
    hMainTable: 0
  }),
  methods: {
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    handleSearch(keyword) {
      this.listQuery.search = keyword;
      this.fetchData();
    },
    tbRowClicked(item, index) {
      this.customer = item;
      this.$refs["customer-contact"].setData(item);
      this.lastIndexCustomerSelected = index;
    },
    tbHandleContextMenuItemClick(a) {
      if (a.menu.key == "verify") {
        customerService
          .verify(a.data.id)
          .then(res => {
            this.$alertify.success(res.message, {
              duration: 4000
            });
            this.lastIndexCustomerSelected = 0;
            this.fetchData();
          })
          .finally(() => {
            this.pending = false;
          });
      } else if (a.menu.key == "edit") {
        this.handleUpdate();
      } else if (a.menu.key == "editManage") {
        this.handleUserManage(a.data);
      }
    },
    handleUserManage(item) {
      this.$refs.userManage.visible = true;
      this.$refs.userManage.setData(item);
    },
    handleBlock(row) {
      let data = {
        customer: {
          isBlock: true
        }
      };
      this.pending = true;
      var self = this;
      customerService
        .update(row.id, data)
        .then(() => {
          self.$alertify.warning("Đã khóa khách hàng thành công", {
            duration: 2000
          });
        })
        .finally(() => {
          self.pending = false;
        });
      row.isBlock = true;
    },
    handleUnBlock(row) {
      let data = {
        customer: {
          isBlock: false
        }
      };
      this.pending = true;
      var self = this;
      customerService
        .update(row.id, data)
        .then(() => {
          self.$alertify.success("Đã kích hoạt khách hàng thành công", {
            duration: 2000
          });
        })
        .finally(() => {
          self.pending = false;
        });
      row.isBlock = false;
    },
    handleUpdate() {
      this.$refs["customer-modal"].visible = true;
      this.$refs["customer-modal"].setStep(0);
      this.$refs["customer-modal"].setData(Object.assign({}, this.customer));
    },
    handleCreate() {
      this.$refs["customer-modal"].setStep(0);
      this.$refs["customer-modal"].visible = true;
      this.$refs["customer-modal"].setData({});
    },
    handleCopy() {
      this.$refs["customer-modal"].visible = true;
      this.$refs["customer-modal"].setStep(0);
      let mcustomer = Object.assign({}, this.customer);
      delete mcustomer.id;
      this.$refs["customer-modal"].setData(Object.assign({}, this.customer));
    },
    handleHelp() {
      alert("help");
    },
    handleDelete() {
      if (this.countChecked == 0) return;
      this.pending = true;
      let listRemove = [];
      this.customerSelecteds.forEach(element => {
        listRemove.push(element.id);
      });
      customerService
        .removeList({ list: listRemove })
        .then(() => {
          this.lastIndexCustomerSelected = 0;
          this.fetchData();
        })
        .finally(() => {
          this.pending = false;
        });
    },
    handleChangeDataCustomerContact() {
      this.fetchData();
    },
    handleCreateQuota() {
      this.$router.push({
        name: "add-quotation",
        query: { id_customer: this.customer.id }
      });
    },
    tbSetRowSelected(items) {
      this.customerSelecteds = items;
      this.countChecked = items.length;
    },
    async fetchData() {
      this.pending = true;
      customerService
        .findAll(this.listQuery)
        .then(res => {
          this.tableData = res.data.data;
          this.listQuery.total = res.data.total;
          this.$refs["soft-table"].selectRow(this.lastIndexCustomerSelected);
        })
        .finally(() => {
          this.pending = false;
        });
    },
    resize() {
      this.hMainTable = this.$hMainContent - 64;
    }
  },
  created() {
    this.fetchData();
    var self = this;
    self.resize();
    window.onresize = function() {
      self.resize();
    };
  }
};
</script>

<style></style>
